/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseIcon16Light = forwardRef('MediaUiAPauseIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 2.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0v-11Z" }),
        React.createElement("path", { d: "M11 2.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0v-11Z" })));
});
